const threeSlides = document.querySelectorAll(".slides-container .three")
const containerWrapper = document.querySelector(".slider-container-wrapper")
const viewWrapper = document.querySelector(".slider-wrapper")
const slidesContainer = document.querySelector(".slides-container")

  if(containerWrapper.clientWidth < 1300){
    threeSlides.forEach((threeSlide)=>{
      threeSlide.style.minWidth = viewWrapper.clientWidth + 'px'
    })
  }

const ro = new ResizeObserver(() => {
      if(containerWrapper.clientWidth < 1300){
        threeSlides.forEach((threeSlide)=>{
          threeSlide.style.minWidth = viewWrapper.clientWidth + 'px'
        })
      }
    
  });
  ro.observe(document.querySelector('html'));

  
document.getElementById("slide-arrow-left").addEventListener("click", () => {
  viewWrapper.scrollLeft += ((slidesContainer.clientWidth - (threeSlides[0].clientWidth * 3))*0.5) + threeSlides[0].clientWidth;
});

document.getElementById("slide-arrow-right").addEventListener("click", () => {
  viewWrapper.scrollLeft -= ((slidesContainer.clientWidth - (threeSlides[0].clientWidth * 3))*0.5) + threeSlides[0].clientWidth;
});

